import downArrowIcon from "./assets/icons/down-arrow-icon.png";
import upArrowIcon from "./assets/icons/up-arrow-icon.png";
import circleIcon from "./assets/icons/circle-icon.png";
import diamondIcon from "./assets/icons/diamond-icon.png";
import squareIcon from "./assets/icons/square-icon.png";
import fireIcon from "./assets/icons/fire-icon.png";
import buildingIcon from "./assets/icons/building-icon.png";
import endangeredSite from "./assets/icons/endangered-site-icon.png";

export const iconConfig = {
  diamond: {
    name: "diamond",
    url: diamondIcon,
    width: 160,
    height: 160,
    anchorX: 80,
    anchorY: 80,
    mask: true,
  },
  "down-arrow": {
    name: "down arrow",
    url: downArrowIcon,
    width: 160,
    height: 160,
    anchorX: 80,
    anchorY: 80,
    mask: true,
  },
  "up-arrow": {
    name: "up arrow",
    url: upArrowIcon,
    width: 160,
    height: 160,
    anchorX: 80,
    anchorY: 80,
    mask: true,
  },
  circle: {
    name: "circle",
    url: circleIcon,
    width: 160,
    height: 160,
    anchorX: 80,
    anchorY: 80,
    mask: true,
  },
  square: {
    name: "square",
    url: squareIcon,
    width: 160,
    height: 160,
    anchorX: 80,
    anchorY: 80,
    mask: true,
  },
  fire: {
    name: "fire",
    url: fireIcon,
    width: 1024,
    height: 1024,
    anchorX: 512,
    anchorY: 512,
    mask: false,
  },
  building: {
    name: "building",
    url: buildingIcon,
    width: 1024,
    height: 1024,
    anchorX: 512,
    anchorY: 512,
    mask: false,
  },
  "endangered-site": {
    name: "endangered-site",
    url: endangeredSite,
    width: 1024,
    height: 1024,
    anchorX: 512,
    anchorY: 512,
    mask: false,
  },
};
